import { OrderSet } from '@exodus/models'

export const getIncomingOrders = ({ orderSet, assetName, walletAccount }) =>
  OrderSet.fromArray(
    [...orderSet].filter(
      ({ toWalletAccount, toAsset }) => toAsset === assetName && walletAccount === toWalletAccount
    )
  )
